/* eslint-disable @typescript-eslint/ban-types */
import { isFunction, isPlainObject } from 'lodash';
import { isRef } from 'vue';

const hasOwn = (obj: Object, key: string): boolean => Object.hasOwnProperty.call(obj, key);

const isNative = (Ctor: any): boolean => {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
};

const hasSymbol =
  typeof Symbol !== 'undefined' &&
  isNative(Symbol) &&
  typeof Reflect !== 'undefined' &&
  isNative(Reflect.ownKeys);

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(from: Record<string, any>, to: Record<string, any>): Object {
  if (!from) return to;
  if (!to) return from;

  let key: any;
  let toVal: any;
  let fromVal: any;

  const keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);

  for (let i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') continue;
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      to[key] = fromVal;
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      !isRef(toVal) &&
      isPlainObject(fromVal) &&
      !isRef(fromVal)
    ) {
      mergeData(fromVal, toVal);
    }
  }
  return to;
}

export default function mergeSetup(
  parent: Function,

  child: Function,
) {
  return function mergeSetupFn(props: any, context: any) {
    return mergeData(
      isFunction(parent) ? (parent(props, context) ?? {}) : undefined,
      isFunction(child) ? (child(props, context) ?? {}) : undefined,
    );
  };
}
